import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./refresh.svg?react";

export const RefreshIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
